const errors = {
    failedToLoadAutomationNodes: 'Failed to load automation nodes',
    // General
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Please try again',
    failedToLoadApplication: 'Unable to load application',
    
    // Billing Configuration
    failedToLoadBillingConfiguration: 'Failed to load billing configuration',
    failedToSaveBillingConfiguration: 'Failed to save billing configuration',
    atLeastOnePaymentMethodRequired: 'At least one payment method is required',
    invalidTrialPeriod: 'Please enter a valid trial period',
    
    // Billing Cycles
    failedToLoadBillingCycles: 'Failed to load billing cycles',
    failedToUpdateBillingCycle: 'Failed to update billing cycle',
    failedToCreateBillingCycle: 'Failed to create billing cycle',
    failedToRemoveBillingCycle: 'Failed to remove billing cycle',
    
    // Credit Management
    failedToLoadCreditManagement: 'Failed to load credit management settings',
    failedToSaveCreditManagement: 'Failed to save credit management settings',

    // General API
    requestFailed: 'Request failed',
    networkError: 'Network error occurred',
    validationError: 'Validation error',
    failedToLoadCustomers: 'Failed to load customers',
    failedToLoadProducts: 'Failed to load products.',
    failedToLoadProduct: 'Failed to load product.',
  } as const;

export default errors;
